export const defaultAvatarUrl = '/public/base/images/default-avatar.png'
